// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorFallback_container__5hRzh","title":"ErrorFallback_title__HdoLe","message":"ErrorFallback_message__N6yiq","button":"ErrorFallback_button__wS9yp"};